const AUTH_COOKIE_NAME = "jwtToken";
const AUTH_COOKIE_MAX_AGE_SECONDS = 86400;
const tokenListeners = new Set();

export function subscribeAuthTokenChanges(listener) {
  tokenListeners.add(listener);
  return () => tokenListeners.delete(listener);
}

function notifyTokenChange() {
  tokenListeners.forEach(listener => listener());
}

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === "token" || event.key === null) notifyTokenChange();
  });
}

function getCookieValue(name) {
  if (typeof document === "undefined") return null;
  const cookiePrefix = `${name}=`;
  const cookie = document.cookie
    .split(";")
    .map(value => value.trim())
    .find(value => value.startsWith(cookiePrefix));

  if (!cookie) return null;

  return decodeURIComponent(cookie.slice(cookiePrefix.length));
}

function getSecureCookieAttribute() {
  if (typeof window === "undefined" || !window.location || window.location.protocol !== "https:") {
    return "";
  }

  return "; secure";
}

export function getStoredAuthToken() {
  if (typeof localStorage !== "undefined") {
    const localStorageToken = localStorage.getItem("token");
    if (localStorageToken && localStorageToken !== "undefined" && localStorageToken !== "null") {
      return localStorageToken;
    }
  }

  const cookieToken = getCookieValue(AUTH_COOKIE_NAME);
  if (cookieToken && typeof localStorage !== "undefined") {
    localStorage.setItem("token", cookieToken);
  }

  return cookieToken;
}

export function persistAuthToken(token) {
  const changed = getStoredAuthToken() !== token;
  localStorage.token = token;

  if (typeof document !== "undefined") {
    document.cookie = `jwtToken=${encodeURIComponent(token)}; path=/; max-age=${AUTH_COOKIE_MAX_AGE_SECONDS}; samesite=lax${getSecureCookieAttribute()}`;
  }
  if (changed) notifyTokenChange();
}

export function removeAuthToken() {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("token");
  }

  if (typeof document !== "undefined") {
    document.cookie = `${AUTH_COOKIE_NAME}=; path=/; max-age=0; samesite=lax${getSecureCookieAttribute()}`;
  }
  notifyTokenChange();
}
